import { render, staticRenderFns } from "./quitInherit.vue?vue&type=template&id=7bdab932&scoped=true&"
import script from "./quitInherit.vue?vue&type=script&lang=js&"
export * from "./quitInherit.vue?vue&type=script&lang=js&"
import style0 from "./quitInherit.vue?vue&type=style&index=0&id=7bdab932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdab932",
  null
  
)

export default component.exports